/*
 * File: d:\projects\AutoFiFront\src\Utils\GetCatIconToDisplay.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 2:14:09 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Break from 'Content/SVG/CategorySVG/Break';
import Citycar from 'Content/SVG/CategorySVG/Citycar';
import Sedan from 'Content/SVG/CategorySVG/Sedan';
import SUV from 'Content/SVG/CategorySVG/SUV';
import Utility from 'Content/SVG/CategorySVG/Utility';
import { SVGProps } from 'Content/SVG/SVGProps';

const getCatIconToDisplay = (category: string, props:SVGProps) => {
    let myRet;
    switch (category) {
        case "suv":
            myRet = <SUV fill={props.fill} width={props.width} height={props.height} stroke={props.stroke} strokeWidth={props.strokeWidth}/>;
            break;
        case "break":
            myRet = <Break fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth}/>;
            break;
        case "citycar":
            myRet = <Citycar fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth}/>;
            break;
        case "sedan":
            myRet = <Sedan fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth}/>;
            break;
        case "utility":
            myRet = <Utility fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth}/>;
            break;
        default:
            break;
    }
    return myRet;
};

export default getCatIconToDisplay;
